module.exports = __webpack_public_path__ + "img/email_not_verified.95bba7ef.svg";